<template>
  <div
    :class="{ 'form-control': true, required: $required, error: $error }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    control: {
      type: Object,
      required: false
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    error: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    $required () {
      return (
        (this.control && this.control.$params.required) ||
        (!this.control && this.required)
      )
    },
    $error () {
      return (
        (this.control && this.control.$error) ||
        (!this.control && this.error)
      )
    }
  }
}
</script>

<style lang="scss">
    .form-control {
    display: flex;
    flex-direction: column;

    &.required label:after {
      content: '*';
      display: inline-block;
      position: relative;
    }

    &.error {
      .form-control-feedback {
        display: block;
      }
    }

    .form-control-feedback {
      display: none;
    }
  }

  .form-control {
    &.error {
      label, .form-control-feedback {
        color: $deprecated-color-ui-error
      }
    }
  }
</style>
